<template>
  <div id="app">
    <el-container>
      <el-header class="header-top" style="height: 80px !important">
        <!-- <div class="logo">
          <img src="@/assets/img/toplogo.png" alt />
        </div> -->
        <div class="container">
          <div class="left">
            <div class="title">趣比价</div>
            <div class="name">qubijia.com</div>
          </div>
          <div class="right">
            <h3>比价API接口</h3>
          </div>
        </div>
      </el-header>

      <div class="header-menu">
        <div class="box-menu">
          <div class="menu-top">
            <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" background-color="#333"
              text-color="#fff" active-text-color="#fff" @select="handleSelect" :router="router">
              <el-menu-item index="/">首页</el-menu-item>
              <el-menu-item index="/comparison">比价搜索API</el-menu-item>
              <el-menu-item index="/priceMonitor">价格监控系统</el-menu-item>
              <el-menu-item index="/analysis">商品数据分析</el-menu-item>
              <el-menu-item index="/about">关于我们</el-menu-item>
              <!-- <el-menu-item index="/news">新闻资讯</el-menu-item>
              <el-menu-item index="/product">产品中心</el-menu-item>
              <el-menu-item index="/case">经典案例</el-menu-item>
              <el-menu-item index="/goin">走进科建</el-menu-item>
              <el-menu-item index="/download">下载APP</el-menu-item> -->
            </el-menu>
          </div>
        </div>
      </div>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div>Copyright © 2012-2022 manmanbuy.com All Rights Reserved.</div>
        <div>趣比价--专业的商品比价API接口数据提供商</div>
        <div class="footer-content">
          <!-- <ul class="content-nav">
            <li>
              <p>走进科建</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：kejianlml@163.com</span>
              <span>电话：021-55802368</span>
              <span>地址：上海市杨浦区翔殷路128号12号楼101</span>
            </li>
          </ul> -->
        </div>
        <!-- <div class="copyright">
          <span>科建版权所有</span>
        </div> -->
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/home",
      isShow: true
    };
  },
  watch: {
    // 监听路由变化
    '$route': {
      immediate: true,
      handler(route) {
        // 根据路由的path更新activeMenu
        this.defaultActive = route.path;
      }
    }
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.header-top {
  height: 80px !important;
  .container {
    display: flex;
    align-items: center;
    .left {
      margin-right: 30px;
      text-align: center;
      .title {
        font-weight: bold; /* 粗体 */
        font-size: 40px; /* 字体大小 */
        /* 可以添加其他样式，如颜色、阴影等来增强视觉效果 */
        color: rgb(234, 82, 61); /* 文字颜色 */
        text-shadow: 1px 1px 2px #AAAAAA; /* 文字阴影 */
      }
      .name {
        color: rgb(234, 82, 61); /* 文字颜色 */
        text-shadow: 1px 1px 2px #AAAAAA; /* 文字阴影 */
      }
    }
  }
}

.header-menu {
  background-color: #333;
  font-weight: 700;

  .box-menu {
    width: 994px;
    margin: 0px auto;
    text-align: center;
    // line-height: 18px;

    .menu-top {
      height: 40px;
      text-align: left;
      line-height: 40px;
    }
  }
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 994px;
  margin: 0 auto;
  padding: 0 !important;
  //background-color: #fff;

  .logo {
    // height: 80px;
    line-height: 80px;
    width: 280px;
    padding: 10px;

    img {
      width: 100%;
      // line-height: 60px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  background-color: #444;
  height: 70px;
  color: #DADADA;
  font-size: 12px;
  text-align: center;
  padding-top: 20px;
  line-height: 30px;
  width: 100%;
  // height: 216px;
  overflow: hidden;
  // background-color: #14679f;

  &-content {
    width: 994px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;

    .content-nav {
      display: flex;
      justify-content: space-around;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;

        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }

        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }

    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }

  .copyright {
    height: 30px;
    background: #125688;

    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
